import React from "react";
import { FEATURES, MARGIN_PAIN_ITEMS, MARGIN_CARDS } from "../marketingData";

const FeatureIcon = ({ type }) => {
  const paths = {
    shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
    truck: (
      <>
        <path d="M1 3h15v13H1z" />
        <path d="M16 8h4l3 3v5h-7V8z" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </>
    ),
    dollar: (
      <>
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
      </>
    ),
    search: (
      <>
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </>
    ),
    activity: <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />,
    mail: (
      <>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      {paths[type]}
    </svg>
  );
};

const FeaturesSection = () => (
  <>
    <section className="features-section" id="features">
      <div className="features-header reveal">
        <span className="section-eyebrow">Platform features</span>
        <h2 className="section-h2">
          Everything a real
          <br />
          ecommerce operator <em>needs.</em>
        </h2>
      </div>
      <div className="features-grid">
        {FEATURES.map((feat, index) => (
          <div className={`feat-card reveal stagger-${(index % 3) + 1}`} key={feat.title}>
            <div className="feat-top">
              <div className="feat-icon">
                <FeatureIcon type={feat.icon} />
              </div>
              <div className="feat-title">{feat.title}</div>
            </div>
            <div className="feat-bottom">
              <div className="feat-desc">{feat.desc}</div>
              <div className="feat-bar-wrap">
                <div className="feat-bar" style={{ "--w": feat.bar }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>

    <div className="margin-section">
      <div className="margin-inner">
        <div className="margin-grid">
          <div className="reveal-left">
            <span className="section-eyebrow">Margin reality</span>
            <h2 className="section-h2" style={{ color: "var(--white)" }}>
              Scale without
              <br />
              freezing your <em>capital.</em>
            </h2>
            <p className="section-p" style={{ color: "#555" }}>
              Most platforms eat into your margin before your customer even places an order. We built
              Ecomdropship so you can expand your catalog, scale your ads, and grow — without buying
              inventory upfront or paying warehouse bills.
            </p>
            <div className="margin-pain-list">
              {MARGIN_PAIN_ITEMS.map((item, i) => (
                <div className="margin-pain-item" key={i}>
                  <div className="margin-pain-icon">
                    <FeatureIcon type={i === 0 ? "dollar" : i === 1 ? "shield" : "activity"} />
                  </div>
                  <div className="margin-pain-text">{item.text}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="margin-right reveal-right">
            {MARGIN_CARDS.map((card) => (
              <div className="margin-card" key={card.label}>
                <div className="margin-card-label">{card.label}</div>
                <div className="margin-card-value">{card.value}</div>
                <div className="margin-card-sub">{card.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
);

export default FeaturesSection;
